import { ChainId, Token } from '@noahswap/sdk'
import { EUSD_EVM, NOAH_MAINNET, USDT_EVM } from './common'

export const evmTokens = {
  usdt: USDT_EVM,
}
